import React, { useState } from "react";
import CustomTabs from "components/tabs/customTab";
import { FileText, Plus, Settings } from "lucide-react";
import SelectReportType from "./SelectReportType";
import ConfigureReport from "./ConfigureReport";
import ReportHistory from "./ReportHistory";
import dayjs from "dayjs";
import ReportTemplate from "./ReportTemplate";

const ReportsTab = ({
  analyticsCards,
  selectedReport,
  onSelectReport,
  onGenerateReport,
  generatedReports,
  onDeleteReport,
}) => {
  const [activeTab, setActiveTab] = useState("generate");

  const [tempDepartments, setTempDepartments] = useState([]);
  const [tempDateRange, setTempDateRange] = useState([
    dayjs("2025-10-01"),
    dayjs("2025-10-13"),
  ]);

  const TabLabel = ({ text, icon: Icon }) => (
    <div className="flex items-center justify-center gap-2">
      <Icon className="h-4 w-4" />
      <span className="text-sm font-medium">{text}</span>
    </div>
  );

  const tabOptions = [
    { label: <TabLabel icon={Plus} text="Generate Report" />, value: "generate" },
    { label: <TabLabel icon={FileText} text={`Report History (${generatedReports.length})`} />, value: "history" },
    { label: <TabLabel icon={Settings} text="Templates" />, value: "templates" },
  ];

  const resetTempStates = () => {
    setTempDepartments([]);
    setTempDateRange([dayjs("2025-10-01"), dayjs("2025-10-13")]);
  };

  return (
    <div className="flex flex-col gap-4">
      <CustomTabs
        tabs={tabOptions}
        height="h-10"
        activeTab={activeTab}
        onChange={setActiveTab}
      />

      <div className="mt-3 space-y-4">
        {activeTab === "generate" && (
          <div className="flex flex-col space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
              <SelectReportType
                analyticsCards={analyticsCards}
                selectedCard={selectedReport}
                onSelectCard={onSelectReport}
              />

              <ConfigureReport
                selectedReport={selectedReport}
                onSelectReport={onSelectReport}
                selectedDepartments={tempDepartments}
                setSelectedDepartments={setTempDepartments}
                dateRange={tempDateRange}
                setDateRange={setTempDateRange}
                analyticsCards={analyticsCards}
                onGenerateReport={(newReport) => {
                  onGenerateReport(newReport);
                  resetTempStates();
                  setActiveTab("history");
                }}
              />
            </div>
          </div>
        )}

        {activeTab === "history" && (
          <div className="space-y-6">
            <ReportHistory
              analyticsCards={generatedReports}
              onDeleteReport={onDeleteReport}
            />
          </div>
        )}

        {activeTab === "templates" && 
        <div className="space-y-6">
          <ReportTemplate
            analyticsCards={analyticsCards}
            selectedCard={selectedReport}
            onSelectCard={onSelectReport}
            setActiveTab={setActiveTab}
          />
        </div>}
      </div>
    </div>
  );
};

export default ReportsTab;
